const initialState = {
  ledgerData: [],
  credit: 0,
  debit: 0,
  loading: false,
  error: null,
};

const cashBookState = {
  data: [],
  cashInHand: 0,
  openingBalance: 0,
  cashAccounts: [],
  credit: 0,
  debit: 0,
  loading: false,
  error: null,
};

export const cashBookReducer = (state = cashBookState, action) => {
  switch (action.type) {
    case "GET_CASH_BOOK_DATA":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const customerLedgerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CUSTOMER_LEDGER":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
const generalState = {
  transactionData: [],
  transactionDebitTotal: 0,
  transactionCreditTotal: 0,
  loading: false,
  error: null,
};

export const generalLedgerReducer = (state = generalState, action) => {
  switch (action.type) {
    case "GENERAL_LEDGER":
      return {
        ...state,
        ...action.payload,
      };
    case "RESET_GENERAL_LEDGER":
      return { ...generalState };
    default:
      return state;
  }
};

const genLedger = {
  ledgerData: [],
  accountData: null,
  fromDate: null,
  toDate: null,
  openingBalanceType: null,
  openingBalance: 0,
  openingBalanceDate: null,
  credit: 0,
  debit: 0,
  loading: false,
  error: null,
};

export const generalLedgerDataReducer = (state = genLedger, action) => {
  switch (action.type) {
    case "GENERAL_LEDGER_DATA":
      return {
        ...state,
        ...action.payload,
      };
    case "RESET_GENERAL_LEDGER_DATA":
      return { ...genLedger };
    default:
      return state;
  }
};

const recoveryInstall = {
  recovery: [],
  totalDue: 0,
  totalReceived: 0,
  totalReceivable: 0,
  loading: false,
  error: null,
};

export const installmentRecoveryReducer = (state = recoveryInstall, action) => {
  switch (action.type) {
    case "INSTALLMENT_RECOVERY":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const bankBalanceInit = {
  data: [],
  bankBalance: 0,
  openingBalance: 0,
  bankAccounts: [],
  credit: 0,
  debit: 0,
  loading: false,
  error: null,
};
export const bankBalanceReducer = (state = bankBalanceInit, action) => {
  switch (action.type) {
    case "GET_BANK_BALANCE_REPORT":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const waRed = {
  data: [],
  loading: false,
  error: null,
};

export const waHistoryReducer = (state = waRed, action) => {
  switch (action.type) {
    case "WHATSAPP_HISTORY":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
const commRed = {
  data: [],
  loading: false,
  error: null,
};

export const reserveCommissionPayableReducer = (state = commRed, action) => {
  switch (action.type) {
    case "RESERVE_COMMISSION_PAYABLE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const trialRed = {
  data: [],
  loading: false,
  credit: 0,
  debit: 0,
  debitGrandTotal: 0,
  creditGrandTotal: 0,
  openingDebittotal: 0,
  closingDebittotal: 0,
  openingCredittotal: 0,
  closingCredittotal: 0,
  error: null,
};

export const trialBalanceReducer = (state = trialRed, action) => {
  switch (action.type) {
    case "TRIAL_BALANCE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

// reducers/generalJournalReducer.js

const genjournal = {
  journalEntries: [],
  summary: {
    credit: 0,
    debit: 0,
  },
};

export const generalJournalReducer = (state = genjournal, action) => {
  switch (action.type) {
    case "SET_GENERAL_JOURNAL_DATA":
      return {
        ...state,
        journalEntries: action.payload.entries,
        summary: action.payload.summary,
      };
    default:
      return state;
  }
};

const commReceipt = {
  receipts: [],
};

export const commissionReceiptsReducer = (state = commReceipt, action) => {
  switch (action.type) {
    case "SET_COMMISSION_RECEIPTS_DATA":
      return {
        ...state,
        receipts: action.payload,
      };
    default:
      return state;
  }
};

const customerReport = { data: [], loading: false };

export const GetCustomerReportRed = (state = customerReport, action) => {
  switch (action.type) {
    case "get_customerreport":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
